import { FeatureFlags } from 'yeself-common/typings/FeatureFlags';

import EnvironmentConfiguration from 'yeself-client-common/EnvironmentConfiguration';

export const featureFlagsInitialState = (): FeatureFlags =>
    Object.keys(EnvironmentConfiguration.FEATURE_FLAGS).reduce(
        (prev, curr) => ({ ...prev, [curr]: undefined }),
        {} as FeatureFlags
    );

export const featureFlagsFromGlobalConfig = (): FeatureFlags => EnvironmentConfiguration.FEATURE_FLAGS;
